type OptionType = 'CVC' | 'layout' | 'length';

function cardNumberOptions (
  isAmericanExpressCard: boolean,
  optionType: 'CVC' | 'layout' | 'length',
  getRegex?: boolean
) {
  const options: Record<OptionType, { value?: string; regex?: RegExp }> = {
    CVC: {
      value: isAmericanExpressCard ? '####' : '###',
      regex: isAmericanExpressCard ? /^\d{4}$/ : /^\d{3}$/
    },
    layout: {
      value: isAmericanExpressCard ? '#### ###### #####' : '#### #### #### ####'
    },
    length: {
      regex: isAmericanExpressCard ? /^\d{15}$/ : /^\d{16}$/
    }
  }

  const option = options[optionType]
  return getRegex ? option.regex : option.value
}

export { cardNumberOptions }
